/**
 * Persönliche Darstellung: helles oder dunkles Kora, und welche drei Töne die
 * Liegezeit benutzt.
 *
 * Die Wahrheit steht in der Datenbank am Nutzer – nur so gilt sie auch am
 * zweiten Rechner. Zusätzlich liegt sie im localStorage, und zwar aus einem
 * einzigen Grund: Zwischen dem ersten Bild der Seite und der Antwort von
 * /auth/ich vergeht rund eine halbe Sekunde. Ohne die Kopie im Browser wäre
 * das eine halbe Sekunde weißes Aufblitzen, jedes Mal. Das kleine Skript in
 * index.html liest diese Kopie, bevor überhaupt etwas gezeichnet wird.
 *
 * Der localStorage ist damit ein Vorgriff, keine Quelle: Sobald der Nutzer
 * geladen ist, gewinnt der Wert aus der Datenbank.
 */

import type { AmpelSchluessel, ThemaSchluessel } from '../typen';

export const SPEICHER_THEMA = 'kora.thema';
export const SPEICHER_AMPEL = 'kora.ampel';

/** Löst „system" gegen das auf, was Windows bzw. das Telefon gerade sagt. */
export function themaAufloesen(thema: ThemaSchluessel): 'hell' | 'dunkel' {
  if (thema !== 'system') return thema;
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dunkel' : 'hell';
}

/** Setzt die Attribute, an denen tokens.css hängt. */
export function darstellungAnwenden(thema: ThemaSchluessel, ampel: AmpelSchluessel): void {
  const wurzel = document.documentElement;
  const aufgeloest = themaAufloesen(thema);
  wurzel.dataset.thema = aufgeloest;
  wurzel.dataset.ampel = ampel;

  // Der Browser färbt Scrollbalken und Formularelemente danach ein.
  wurzel.style.colorScheme = aufgeloest === 'dunkel' ? 'dark' : 'light';

  try {
    localStorage.setItem(SPEICHER_THEMA, thema);
    localStorage.setItem(SPEICHER_AMPEL, ampel);
  } catch {
    // Privater Modus oder gesperrter Speicher: dann blitzt es eben kurz weiß.
    // Kein Grund, deshalb die Anwendung anzuhalten.
  }
}
